/**
 * Component for displaying a placeholder when a track is offline
 */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * OfflineTrackPlaceholder component displays a placeholder when a track is offline
 *
 * @param {object} props - Component props
 * @param {string} props.trackSid - The track SID for identification
 * @returns {React.ReactElement} - The rendered component
 */
const OfflineTrackPlaceholder = ({ trackSid }) => {
  return (
    <div
      className="empty-track-placeholder"
      data-track-sid={trackSid}
      style={{
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#000',
        fontSize: '14px',
      }}
    >
      Participant offline
    </div>
  );
};

OfflineTrackPlaceholder.propTypes = {
  trackSid: PropTypes.string.isRequired,
};

export default OfflineTrackPlaceholder;
